var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('h2',[_vm._v("Edit")])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('editor',{ref:"toastEditor",attrs:{"initialValue":_vm.content,"height":"400px","initialEditType":"wysiwyg","useCommandShortcut":"true"},on:{"change":_vm.onEditorChange}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }